import { t } from "i18next"

const HeadingText  = ({text, className="" ,style, contentProps})=>{
    return <h3 className={`m-0 text-24x font-bold text-dark-blue-900 leading-none ${className}`} style={style}>{t(text, contentProps)}</h3>
}

const SubHeadingText  = ({text, className="" ,style, contentProps})=>{
    return <p className={`m-0 text-16x font-medium text-dark-blue-900 ${className}`} style={style}>{t(text, contentProps)}</p>
}

const TranslationText  = ({text, className="" ,style, contentProps, as="span"})=>{
    const Tag = as || "span";
    return <Tag className={`m-0 ${className}`} style={style}>{t(text, contentProps)}</Tag>
}

export {HeadingText, SubHeadingText, TranslationText}